import { render, staticRenderFns } from "./SampleDescription.vue?vue&type=template&id=7c2911ee&"
import script from "./SampleDescription.vue?vue&type=script&lang=ts&"
export * from "./SampleDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports